import { createContext, useContext } from "react";
export const CtaSettingContext = createContext(undefined);
export const useCtaSettingContext = () => useContext(CtaSettingContext);
